import { Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { Preferences } from '@vendasta/meetings';
import {
  INTEGRATIONS_PAGE_LINK_TOKEN,
  MEETING_INTEGRATION_SERVICE_KEYS_TOKEN,
  PERSONAL_CALENDAR_ID_TOKEN,
  RECOMMENDED_PERSONAL_CALENDAR_SLUGS_TOKEN,
} from '../../data-providers/providers';
import { combineLatest, map } from 'rxjs';
import { AvailableServices, MeetingViewModelService } from '@vendasta/integrations';
import { ScheduleSettingsViewService } from '../schedule-settings-view.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'meeting-scheduler-settings',
  templateUrl: './schedule-settings.component.html',
  styleUrls: ['./schedule-settings.component.scss'],
  standalone: false,
})
export class ScheduleSettingsComponent {
  isHostConfigured = input<boolean>(false);
  isGoogleMeetConfigured = input<boolean>(false);
  isMicrosoftConfigured = input<boolean>(false);
  hostPreferences = input<Preferences>(undefined);

  readonly enableTracking = true;

  protected readonly meetingViewModelService = inject(MeetingViewModelService);
  protected readonly scheduleSettingsViewService = inject(ScheduleSettingsViewService);
  protected readonly destroyRef = inject(DestroyRef);


  protected readonly SERVICE_KEYS = inject(MEETING_INTEGRATION_SERVICE_KEYS_TOKEN);
  protected readonly integrationsPageLink$ = inject(INTEGRATIONS_PAGE_LINK_TOKEN);
  protected readonly recommendedSlugs$ = inject(RECOMMENDED_PERSONAL_CALENDAR_SLUGS_TOKEN);
  protected readonly personalCalendarId$ = inject(PERSONAL_CALENDAR_ID_TOKEN);

  protected readonly meetingAppSelection$ = this.scheduleSettingsViewService.meetingAppSelection$;

  isGoogleMeetConnected = signal<boolean | undefined>(undefined);
  selectedCalendarProvider = signal<string | undefined>(undefined);

  constructor() {
    effect(() => {
      combineLatest([
        this.meetingViewModelService.isServiceConnected$(AvailableServices.GOOGLE_MEET),
        this.meetingAppSelection$,
      ])
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          map(([connected, selection]) => {
            return connected && selection === AvailableServices.GOOGLE_MEET;
          }),
        )
        .subscribe((connected) => {
          this.isGoogleMeetConnected.set(connected);
        });
    });
  }

  handleCalendarProvider(provider: string) {
    this.selectedCalendarProvider.set(provider);
  }
}
